import { render, staticRenderFns } from "./CardDOwnloadZipDocumentAdmin.vue?vue&type=template&id=3fce352e&scoped=true"
import script from "./CardDOwnloadZipDocumentAdmin.vue?vue&type=script&lang=js"
export * from "./CardDOwnloadZipDocumentAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fce352e",
  null
  
)

export default component.exports